import { render, staticRenderFns } from "./BlogAdvertisingStrategies.vue?vue&type=template&id=5737e02c"
import script from "./BlogAdvertisingStrategies.vue?vue&type=script&lang=js"
export * from "./BlogAdvertisingStrategies.vue?vue&type=script&lang=js"
import style0 from "./BlogAdvertisingStrategies.vue?vue&type=style&index=0&id=5737e02c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports